'use strict';

exports.__esModule = true;
exports.styles = exports.ChatRoomsListView = undefined;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _List = require('../../../../view/List');

var _styles = require('material-ui/styles');

var _Public = require('material-ui-icons/Public');

var _Public2 = _interopRequireDefault(_Public);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var ChatRoomsListView = exports.ChatRoomsListView = (_temp = _class = function (_TableView) {
  _inherits(ChatRoomsListView, _TableView);

  function ChatRoomsListView() {
    _classCallCheck(this, ChatRoomsListView);

    return _possibleConstructorReturn(this, _TableView.apply(this, arguments));
  }

  ChatRoomsListView.prototype.getColumns = function getColumns() {
    var _context = this.context,
        ChatRoomLink = _context.ChatRoomLink,
        UserLink = _context.UserLink,
        Grid = _context.Grid;
    return [// {
    //   id: "id",
    // },
    {
      id: "isPublic",
      label: "",
      renderer: function renderer(value, record) {
        return _react2.default.createElement(_Public2.default, {
          color: value === true ? "primary" : "disabled"
        });
      }
    }, {
      id: "name",
      label: "Название комнаты",
      renderer: function renderer(value, record) {
        return record ? _react2.default.createElement(ChatRoomLink, {
          object: record
        }) : null;
      }
    }, {
      id: "code",
      label: "Уникальный код"
    }, {
      id: "CreatedBy",
      label: "Владелец",
      renderer: function renderer(value) {
        return value ? _react2.default.createElement(UserLink, {
          user: value
        }) : null;
      }
    }, {
      id: "Members",
      label: "Участники",
      renderer: function renderer(value) {
        return value && value.length ? _react2.default.createElement(Grid, {
          container: true,
          spacing: 8
        }, value.map(function (n) {
          var id = n.id;
          return _react2.default.createElement(Grid, {
            key: id,
            item: true
          }, _react2.default.createElement(UserLink, {
            user: n,
            showName: false,
            size: 'small'
          }));
        })) : null;
      }
    }, {
      id: "Invitations",
      label: "Приглашенные",
      renderer: function renderer(value) {
        return value && value.length ? _react2.default.createElement(Grid, {
          container: true,
          spacing: 8
        }, value.map(function (n) {
          var User = n.User;
          return _react2.default.createElement(Grid, {
            key: User.id,
            item: true
          }, _react2.default.createElement(UserLink, {
            user: User,
            showName: false,
            size: 'small'
          }));
        })) : null;
      }
    }];
  };

  return ChatRoomsListView;
}(_List.TableView), _class.defaultProps = _extends({}, _List.TableView.defaultProps, {
  title: "Чат-комнаты"
}), _temp);
exports.styles = _List.styles;
exports.default = (0, _styles.withStyles)(_List.styles)(function (props) {
  return _react2.default.createElement(ChatRoomsListView, props);
});